import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { CreateApiTokenResponseData, CreateApiTokenSchema } from "schema"
import { apiTokensQuery } from "../lib/apiTokensQuery"
import { z } from "zod"

export const useAddApiTokenMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (tokenData: z.infer<typeof CreateApiTokenSchema>) => {
      const { data } = await axios.post("/apiTokens", tokenData)
      return data.data as CreateApiTokenResponseData
    },
    onSuccess: (data: CreateApiTokenResponseData) => {
      const queryKey = apiTokensQuery().queryKey
      queryClient.setQueryData(queryKey, (oldData) => {
        if (!oldData) return
        const newData = [...oldData]
        newData.push(data)
        return newData
      })
    },
  })
}
